import request, { Methods, withToken, RequestType } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_FILES_RESET = 'POST_FILES_RESET';
export const POST_FILES_LOADING = 'POST_FILES_LOADING';
export const POST_FILES_SUCCESS = 'POST_FILES_SUCCESS';
export const POST_FILES_REJECT = 'POST_FILES_REJECT';

//* ACTIONS ------------------------------------------------
export const postFilesReset = () => ({ type: POST_FILES_RESET });
export const postFilesLoading = () => ({ type: POST_FILES_LOADING });
export const postFilesSuccess = (payload) => ({ type: POST_FILES_SUCCESS, payload });
export const postFilesReject = (payload) => ({ type: POST_FILES_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postFilesRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        headers: RequestType.Multipart,
        data,
    }, getState);

    return request(`/Route/web/AddRouteUploadFile`, options);
};


